import { apiClient } from '@/infrastructure/api'
import { SizeSuggestionsApi } from '@itsrever/rever-api'
import {
  toSizingCycle,
  toSizingModelDetail,
  toSizingModels,
  toSizingOverview
} from './dto'

export const sizingApi = new SizeSuggestionsApi(undefined, undefined, apiClient)

async function hasSizingData(storeId: string, signal?: AbortSignal) {
  const result = await sizingApi.getWronglySizedProductsTab({ storeId }, { signal })
  return result.data.show_tab ?? false
}

async function getOverview(
  storeId: string,
  cycleDate?: string,
  signal?: AbortSignal
) {
  const result = await sizingApi.getSizingOverview(
    { storeId, cycleDate },
    { signal }
  )
  return toSizingOverview(result.data)
}

async function getModels(
  storeId: string,
  cycleDate?: string,
  signal?: AbortSignal
) {
  const result = await sizingApi.listSizingModels(
    { storeId, cycleDate },
    { signal }
  )
  return toSizingModels(result.data)
}

async function getModel(
  storeId: string,
  modelKey: string,
  cycleDate?: string,
  signal?: AbortSignal
) {
  const result = await sizingApi.getSizingModel(
    { storeId, modelKey, cycleDate },
    { signal }
  )
  return toSizingModelDetail(result.data)
}

async function getCycle(
  storeId: string,
  cycleDate?: string,
  signal?: AbortSignal
) {
  const result = await sizingApi.getSizingCycle(
    { storeId, cycleDate },
    { signal }
  )
  return toSizingCycle(result.data)
}

export default {
  hasSizingData,
  getOverview,
  getModels,
  getModel,
  getCycle
}
